import {getData, saveData} from "./filehandler";
import {fetchClubIDFromDatabase, supabase} from "./databasehandler";
import {navigateToPage} from "./routehandler";

export function getLoggedInUser() {
    return getData("email");
}

export async function getUserID() {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    return userError ? getData("userId") : user.id;
}

export function setLoggedInUser(userId, email) {
    saveData("userId", userId);
    saveData("email", email);
}

export async function createUser(email, password) {
    try {
        const {data, error: signUpError} = await supabase.auth.signUp({
            email: email,
            password: password,
        })

        if (signUpError != null) {
            console.log(signUpError)
            return signUpError.message;
        }

        const userId = data.user.id;

        const {userTypeData, error: userTypeError} = await supabase.from("UserTypes")
            .insert({
               user_id: userId,
                userType: "CLUB"
            });

        if (userTypeError != null) {
            console.log(userTypeError)
            return userTypeError.message;
        }

        await signInUser(email, password);

        return null;
    } catch (e) {
        return e;
    }
}

export async function createNewClub(userId, email, club, shortClub, contact, phone, address) {
    try {
        const {clubData, error: clubError} = await supabase.from("Clubs")
            .insert({
                user_id: userId,
                club: club,
                shortClub: shortClub,
                contact: contact,
                phone: phone,
                mail: email,
                address: address,
            });

        if (clubError != null) {
            console.log(clubError)
            return "Error creating account";
        }
    } catch (e) {
        console.log(e);
        return e;
    }
}

export async function signInUser(email, password) {
    try {
        const {data, error: authError} = await supabase.auth.signInWithPassword({
            email: email,
            password: password,
        });

        if (authError != null) {
            return "Invalid Credentials";
        }

        const userId = data.user.id;
        const user = data.user.email;

        const result = await isUserClub(userId);

        if (result == null) {
            return "An unexpected error occurred";
        }

        if (!result) {
            return "This request is only allowed for users with type 'club'.";
        }

        setLoggedInUser(userId, user);

        return null;
    } catch (e) {
        return e;
    }
}


export async function signInUserPasswordless(email, acceptSignUp) {
    try {
        const {data, error: authError} = await supabase.auth.signInWithOtp({
            email: email,
            options: {
                shouldCreateUser: acceptSignUp
            }
        });

        if (authError) {
            if (authError.code === "over_email_send_rate_limit") return "An request for logging in is already running. It can take a maximum of 30 seconds before you can send an email again.";

            return "An unexpected error occurred while trying to sign in.";
        }

        return null;
    } catch (e) {
        return e.toString();
    }
}

export async function verifyOTP(email, token) {
    try {
        const {data: { session }, error: authError} = await supabase.auth.verifyOtp({
            email: email,
            token: token,
            type: 'email',
        });

        if (!session?.user?.id || authError) {
            return "Token verification failed";
        }

        const {data: userTypeData, error: fetchError} = await supabase.from("UserTypes")
            .select("delete_user")
            .eq("user_id", session.user.id);


        if (!userTypeData || userTypeData.length < 1) {
            const {data: insertData, error: userTypeError} = await supabase.from("UserTypes")
                .insert({
                    user_id: session.user.id,
                    userType: "CLUB"
                });
        } else if (Array.isArray(userTypeData) && userTypeData.length > 0) {
            userTypeData[0].delete_user = userTypeData[0]?.delete_user ?? ``;

            if (userTypeData[0].delete_user === "DELETE") {
                await signOutUser(false);
                return "Account is deactivated. If this shouldn't be the case, please contact us at klokking@pm.me";
            }
        }

        const accessToken = session.access_token;
        const sessionUserId = session.user.id;
        const sessionUserEmail = session.user.email;

        setLoggedInUser(sessionUserId, sessionUserEmail, accessToken);

        return null;
    } catch (e) {
        return e.toString();
    }
}

export async function signOutUser(navigateToLogin = true) {
    await supabase.auth.signOut();

    if (navigateToLogin) {
        navigateToPage(`login`);
    }
}

export async function isUserClub(userId) {
    const {data: userType, error: fetchError} = await supabase.from("UserTypes")
        .select("userType, delete_user")
        .eq("user_id", userId).single();

    if (fetchError != null) {
        console.log(fetchError);
        return null;
    }

    return (userType.userType === "CLUB" && userType.delete_user !== "DELETE");
}



export async function deleteUser(userId) {
    try {
        const {error: clubError} = await supabase.from("UserTypes")
            .update({
                delete_user: "DELETE"
            })
            .eq("user_id", userId);

        if (clubError != null) {
            console.log(clubError)
            return false;
        }

        return true;
    } catch (e) {
        console.log(e);
        return false;
    }
}

export async function isLoggedIn() {
    const { data, error } = await supabase.auth.getSession();

    if (error != null) return false;
    if (!data.session) return false;
    if (await supabase.auth == null) return false;

    const expiresAt = data.session.expires_at;
    return Math.floor(Date.now() / 1000) < expiresAt;
}

export async function isClubDataAvailable() {
    return await fetchClubIDFromDatabase();
}
